<template>
  <nav 
  class="navbar navbar-expand-lg"
    :class="{'bg-light': ceg_az !== 2, 'bg-custom': ceg_az == 2}"
  >
    
    
    <div class="container-fluid nav-container">
      <!-- Logo hinzufügen -->
      <a class="navbar-brand" href="#">
        <img src="@/assets/bogos.png" alt="Firmenlogo" class="logo">
        <span class="ftr-text">FTR 1.0.1</span>
        <span class="fsz-text"> {{ fsz }}
        </span>
      </a>
      <button 
          class="navbar-toggler" 
          type="button" data-toggle="collapse" 
          data-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          
          <li class="nav-item">
            <router-link class="nav-link" to="/menu">Start</router-link>
          </li>
        
       <!-- Összes megrendelés -->
       <li class="nav-item">
            <router-link class="nav-link" to="/osszesMegrendeles">
              <i class="fas fa-list-alt"></i>Napi összes
            </router-link>
          </li>
        
  <!-- Új megrendelés -->
  <li class="nav-item">
            <router-link class="nav-link" to="/new_order">
              <i class="fas fa-plus-circle"></i>Új megrendelés
            </router-link>
          </li>
        
          <!-- VIR -->
          <li class="nav-item" v-if="currentRouteName === 'osszesMegrendeles'">
            <a class="nav-link" href="#" @click.prevent="syncData">
              <i class="fas fa-sync-alt"></i>VIR
            </a>
          </li>

       


<!-- Neuer Menüeintrag für Saját Fuvarszervező -->
<li class="nav-item">
            <router-link class="nav-link" to="/sajat-osszes">
              <i class="fas fa-calendar-week"></i>Heti összes
            </router-link>
          </li>


<!-- Import-munkák Menüpunkt -->
<li class="nav-item">
  <router-link class="nav-link" to="/import-munkak">
    <i class="fas fa-table"></i>Import-munkák
  </router-link>
</li>



  <li class="nav-item">
    <router-link class="nav-link" to="/WeekTime">
      <i class="fas fa-truck"></i>Diszpécser
    </router-link>
  </li>





<!-- Térkép Menüpunkt -->
<li class="nav-item">
  <router-link class="nav-link" to="/MapOrders">
    <i class="fas fa-globe"></i>Térkép
  </router-link>
</li>


<!-- E-Mail Menüpunkt -->
<li class="nav-item">
  <router-link class="nav-link" to="/EmailList">
    <i class="fas fa-envelope"></i>Email
  </router-link>
</li>


<!-- Törzsadatok -->
    <li class="nav-item dropdown" @mouseleave="showDropdown = false">
      <a class="nav-link dropdown-toggle"
        href="#"
        @click.prevent="showDropdown = !showDropdown"
        :aria-expanded="showDropdown.toString()"
        role="button">
        <i class="fas fa-database"></i> Törzsadatok
      </a>
      
     <div class="dropdown-menu show" v-if="showDropdown">
      <router-link class="dropdown-item" 
        :to="{ name: 'Stammdaten', params: { type: 'ftr_cikk' } }">Cikkek</router-link>
      
        <router-link class="dropdown-item"
        :to="{ name: 'Stammdaten', params: { type: 'ftr_tav' } }">Távolság</router-link>
    
      <router-link class="dropdown-item"
        :to="{ name: 'Stammdaten', params: { type: 'ftr_hely' } }">Hely</router-link>

      <router-link class="dropdown-item"
        :to="{ name: 'Stammdaten', params: { type: 'ftr_fuvarozo' } }">Fuvarozók</router-link>
      <router-link  class="dropdown-item"
        :to="{ name: 'StammdatenUtvonal' , params: { type: 'utvonal' } }">Útvonal</router-link>

      </div>



    </li>





         <!-- Change Log mit Icon -->
         <li class="nav-item">
            <router-link class="nav-link" to="/change-log">
              <i class="fas fa-book"></i>Napló
            </router-link>
          </li>

         <!-- Help -->
         <li class="nav-item">
            <router-link class="nav-link" to="/help">
              <i class="fas fa-question-circle"></i> Help
            </router-link>
          </li>


          <li class="nav-item">
          <router-link class="nav-link" to="/user-settings">
            <i class="fas fa-user-cog"></i> <!-- Icon anstelle von Text -->
          </router-link>
        </li>


        <li class="nav-item">
            <a class="nav-link" href="index.html">
              <i class="fas fa-sign-out-alt"></i>Kilép
            </a>
          </li>


        </ul>
      </div>
    </div>
  </nav>
</template>



<script>
import { mapGetters } from 'vuex';
import axiosInstance from '@/axiosInstance';

export default {

data() {
  return {
    showDropdown: false,
  };
},

  computed: {
    ...mapGetters(['getUserData']),
    ...mapGetters(['getNapiDatum']),
    fsz() {
      return this.getUserData ? this.getUserData.fsz : null;
    },
    ceg_az() {
      return this.getUserData ? this.getUserData.ceg_az : null;
    },
    // Hier holen wir den aktuellen Routen-Namen
    currentRouteName() {
      return this.$route.name;
    },
    // Hier holen wir den `az`, falls die Seite orderDetails aktiv ist
    currentAz() {
      return this.$route.params.az || 0;
    },
    formattedDate() {
      // Verwende das Datum aus dem Vuex Store, wenn verfügbar
      return this.getNapiDatum;
    }
  },
  methods: {
    navigateToChangeLog() {
      let table_name = '';
      let record_id = 0;
      let user = '';

      // Prüfen, welche Seite aktiv ist und die Parameter entsprechend setzen
      if (this.currentRouteName === 'orderDetails') {
        table_name = 'ftr_megrendeles';
        record_id = this.currentAz;
      } else if (this.currentRouteName === 'MenuForm') {
        user = this.fsz;
      }

      // Navigation zu ChangeLog mit den festgelegten Parametern
      this.$router.push({
        name: 'ChangeLog',
        query: {
          user: user,
          table_name: table_name,
          record_id: record_id
        }
      });
    },
    async syncData() {
      try {
  console.log('data sync start');
  const postData = {

    fsz: this.fsz,
    ceg_az: this.ceg_az,
    datum: this.formattedDate  // Verwendet das aktuell angezeigte Datum
  };

  console.log('syncData', postData);

  const response = await axiosInstance.post('/megrendeles/vir_sync.php', postData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.status === 200 && response.data.success) {
    alert('A kiválasztott napon a saját fuvarok szinkronizálása a VIR-be elkezdődött. Az adatok 1-2 percen belül megjelennek a VIR-ben.');
  } else {
    // Fehlermeldung im Detail anzeigen
    console.error('Sync error:', response.data);
    alert('Szinkronizációs hiba: ' + (response.data.message || 'Ismeretlen hiba') + '\nRészletek: ' + JSON.stringify(response.data));
  }
} catch (error) {
  // Detailliertere Fehlermeldung für das Catch-Block
  console.error('API hiba:', error);

  if (error.response) {
    // Server antwortete mit einem Statuscode, der außerhalb des Bereichs von 2xx liegt
    console.error('Server Antwort:', error.response.data);
    alert('Hiba az API kommunikáció során: ' + error.message + '\nSzerver válasz: ' + JSON.stringify(error.response.data));
  } else if (error.request) {
    // Die Anfrage wurde gesendet, aber es kam keine Antwort zurück
    console.error('Keine Antwort vom Server:', error.request);
    alert('Hiba az API kommunikáció során: A szerver nem válaszolt.\nRészletek: ' + error.message);
  } else {
    // Fehler bei der Anfrage selbst (z.B. fehlerhafte URL)
    console.error('Anfrage Fehler:', error.message);
    alert('Hiba az API kommunikáció során: ' + error.message);
  }
}


    }
  


  },
  name: 'NavigationBar'
};
</script>
  
<style scoped>
.logo {
  height: 26px;
  margin-right: 6px;
}

.ftr-text {
  font-size: 0.75em;
  margin-right: 14px;
}

.fsz-text {
  font-size: 0.9em;
  white-space: nowrap;
}

.bg-light {
  background-color: #c8f4fc !important;
}

.bg-custom {
  background-color: #abf588 !important;
}

.nav-container {
  max-width: 100%;
  padding-left: 8px;
  padding-right: 8px;
}

.navbar {
  padding-top: 4px;
  padding-bottom: 4px;
}

.navbar-brand {
  display: flex;
  align-items: center;
  margin-right: 14px;
  white-space: nowrap;
}

.navbar-nav {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.nav-item {
  margin-right: 0;
  white-space: nowrap;
}

.nav-item .nav-link {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 5px;
  font-size: 0.92rem;
  transition: all 0.3s ease;
}

.nav-item .nav-link i {
  font-size: 1em;
  margin-right: 5px;
}

.nav-item .nav-link:hover {
  background-color: #f0f0f0;
  color: #007bff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.nav-item .nav-link:hover i {
  transform: scale(1.15);
}

/* kleinere Desktop-Bildschirme */
@media (max-width: 1400px) {
  .nav-item .nav-link {
    padding: 5px 6px;
    font-size: 0.86rem;
  }

  .nav-item .nav-link i {
    margin-right: 4px;
  }

  .ftr-text {
    margin-right: 8px;
  }

  .navbar-brand {
    margin-right: 8px;
  }

  .logo {
    height: 24px;
  }
}

/* Bootstrap Collapse für Tablet / Handy */
@media (max-width: 991px) {
  .navbar-nav {
    align-items: flex-start;
    gap: 0;
  }

  .nav-item .nav-link {
    padding: 8px 10px;
    font-size: 1rem;
  }
}
</style>